<template functional>
  <div class="card__icon">
    <img :src="props.icon" />
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true }
  }
}
</script>
